import { action } from '@reatom/framework'

import { Redacted, Result } from '@blade/std-lib'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { UnknownError } from '@root/shared'
import { ApiError, apiRequest } from '@root/shared/api'
import { AuthErrorCode } from '@root/shared/api/api-error-code'
import { reatomRequest } from '@root/shared/lib'

import { WrongCredentialsError } from '../../auth-errors'

export const updatePasswordRequestAction = action(
  async (
    ctx,
    currentPassword: Redacted.Redacted,
    newPassword: Redacted.Redacted,
  ) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.user.userChangePasswordCreate, [
        {
          currentPassword: Redacted.value(currentPassword),
          newPassword: Redacted.value(newPassword),
        },
      ]),
    )

    return result.pipe(
      Result.map((_it) => undefined),
      Result.mapError((it) => {
        if (
          ApiError.isOfCodes([
            AuthErrorCode.InvalidCredentials,
            AuthErrorCode.InvalidPassword,
          ])(it)
        ) {
          return new WrongCredentialsError()
        }
        return UnknownError.fallbackToUnknown(it)
      }),
    )
  },
  'updatePasswordRequestAction',
)

export const reatomUpdatePassword = () => {
  const {
    executeAction: updatePasswordAction,
    requestStateAtom: updatePasswordStateAtom,
  } = reatomRequest({
    execAction: updatePasswordRequestAction,
    name: 'updatePassword',
  })

  return {
    updatePasswordAction,
    updatePasswordStateAtom,
  }
}

export const reatomCheckCurrentPassword = () => {
  const {
    executeAction: checkPasswordAction,
    requestStateAtom: checkPasswordStateAtom,
  } = reatomRequest({
    execAction: updatePasswordRequestAction,
    name: 'updatePassword',
  })

  return {
    checkPasswordAction,
    checkPasswordStateAtom,
  }
}
